export default __webpack_public_path__ + "static/media/photo--lg--huda-7.e1208ee4.jpg";